import styled, { keyframes } from 'styled-components';

const TRUNCATE_THRESHOLD = 100;

export const BestQuote = ({ isLoading = true, quote = "", name = "" }) => {
  const isTruncated = quote.length > TRUNCATE_THRESHOLD;
  const displayQuote = isTruncated ? quote.substring(0, TRUNCATE_THRESHOLD) + "..." : quote;

  if (!isLoading) {
    return (
      <Container>
        <QuoteContainer>
          <QuoteText>"{displayQuote}"</QuoteText>
          <Separator />
          <AuthorName>{name}</AuthorName>
        </QuoteContainer>
      </Container>
    );
  }

  return (
    <Container>
      <SkeletonGroup>
        <SkeletonLine $maxWidth="570px" />
        <SkeletonLine $maxWidth="570px" />
      </SkeletonGroup>
      <SkeletonLine $maxWidth="200px" />
    </Container>
  );
};

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  opacity: 0;
  animation: ${fadeIn} 0.5s cubic-bezier(0.65, 0, 0.35, 1) forwards;
`;

const SkeletonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 24px;
`;

const SkeletonLine = styled.div`
  width: 100%;
  max-width: ${props => props.$maxWidth || '570px'};
  height: 24px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.2) 50%,
    rgba(255, 255, 255, 0.1) 100%
  );
  background-size: 1000px 100%;
  border-radius: 100px;
  animation: ${shimmer} 2s infinite linear;
`;

const QuoteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 570px;
  animation: ${fadeInUp} 0.4s ease-out forwards;
  animation-delay: 0.1s;
  opacity: 0;
`;

const QuoteText = styled.p`
  color: var(--Brand-Regular-OKO-White, #FFF);
  text-align: center;
  font-size: var(--size-724, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: 100%; 
  letter-spacing: var(--Letter-Spacing-None, 0);
  margin: 0;
  text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
`;

const Separator = styled.div`
  opacity: 0.3;
  background: var(--Brand-Light-OKO-Light-Blue, #EAEAFC);
  width: 100px;
  height: 2px;
`;

const AuthorName = styled.p`
  color: var(--Background-Brand-Blue-Secondary, #D3D3F8);
  text-align: center;
  font-size: var(--size-316, 16px);
  font-style: normal;
  font-weight: 600;
  letter-spacing: var(--Letter-Spacing-None, 0);
  text-transform: uppercase;
  margin: 0;
`;

